/**
 * @fileoverview AR-924 — Project / Lesson / Activity summary card at the top of the deliverable drawer.
 */

import { Group, Paper, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/** Figma: 120px label column, 8px between rows. */
const LABEL_WIDTH = 120
const ROW_SPACING = 8

interface DeliverableInfoCardProps {
  readonly projectName: string
  readonly lessonTitle: string
  readonly activityTitle: string
}

export function DeliverableInfoCard({ projectName, lessonTitle, activityTitle }: DeliverableInfoCardProps) {
  const { t } = useTranslation()
  const rows = [
    [t('task_tracker.deliverable_drawer.project_label'), projectName],
    [t('task_tracker.deliverable_drawer.lesson_label'), lessonTitle],
    [t('task_tracker.deliverable_drawer.activity_label'), activityTitle],
  ]
  return (
    <Paper withBorder radius="md" p="md">
      <Stack spacing={ROW_SPACING}>
        {rows.map(([label, value]) => (
          <Group key={label} spacing="md" noWrap align="flex-start">
            <Text size="sm" color="dimmed" sx={{ width: LABEL_WIDTH, flexShrink: 0 }}>{label}</Text>
            <Text size="sm" weight={500}>{value}</Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
